import styled from 'styled-components';
import { PlayerDecisionsWrapper } from '../../Decisions/Decisions.style';
import { GamedayLineScoreWrapper } from '../../LineScore/LineScore.style';
import { PlayerDataWrapper, PlayerDecisionWrapper, PlayerDecisionAltWrapper, PlayerStatsWrapper, PlayerInfoWrapper, PlayerMatchupWrapper, PlayerNameWrapper } from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import BREAKPOINTS from '@mlb/react-patterns/v4/style/breakpoints';

const {
    md,
    lg
} = BREAKPOINTS;

export const LineScoreDecisionsWrapper = styled.div`
    ${PlayerDecisionsWrapper} {
        padding-top: var(--gameday-section-padding-sm);
        ${PlayerStatsWrapper} {
            color: var(--gameday-decisions-stats-color);
            span {
                color: var(--gameday-divider-color);
            }
            font-weight: 500;
        }
        ${PlayerNameWrapper} {
            color: var(--gameday-primary-font-color);
        }
        ${PlayerDecisionWrapper} {
            color: var(--gameday-decisions-stats-color);
        }
        line-height: 12px;
        ${PlayerDataWrapper} {
            margin-left: 0px;
        }

        ${PlayerMatchupWrapper} {
            > div:last-child > div:first-child > div {
                border-bottom: none !important;
                margin-top: 0px;
            }
            ${PlayerInfoWrapper} {
                div, span {
                    font-size: 12px;
                }
            }
        }

    }
    ${GamedayLineScoreWrapper} {
        padding: var(--gameday-section-padding-sm) 0px;
        height: 70px;
        box-sizing: content-box;
        @media (min-width: ${md}) {

        }
    }

    padding: 0px ${({sidePadding}) => sidePadding};

    ${({stacked}) => !stacked ? `
        margin: var(--gameday-section-padding-sm) ;
        margin-bottom: 0px;
        display: grid;
        grid-template-columns: minmax(0, 65%) minmax(0, 35%);

        ${PlayerDecisionsWrapper} {
            padding: var(--gameday-section-padding-sm);
            flex-basis: 35%;
            flex-direction: column;
            padding: 0px;
            padding-left: var(--gameday-section-padding-sm);
            ${PlayerMatchupWrapper} {
                ${PlayerInfoWrapper} {
                    div, span {
                        font-size: 14px;
                    }
                }
                 ${PlayerDecisionAltWrapper} {
                    margin-right: 0px;
                }
                ${PlayerStatsWrapper} {
                    margin-left: 8px;
                    font-size: 14px;
                }
            }

        }
        ${GamedayLineScoreWrapper} {
            border-bottom: none;
            border-right: 1px solid var(--gameday-ls-decisions-border-color);
            flex-basis: 65%;
            padding-bottom: 0px;

            >div {
                max-width: 100%;
                padding-right: var(--gameday-section-padding-sm);
            }
        }
    ` : `
        ${PlayerStatsWrapper} {
            margin-top: 5px;
        }

    `}
`;
